
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ name: 'Spinner' })
export default class Spinner extends Vue {
  @Prop({ default: '' })
  readonly type!: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | '';
  @Prop({ default: false })
  readonly small!: boolean;

  get cls(): string[] {
    const classes: string[] = [];
    if (this.type) {
      classes.push('text-' + this.type);
    }
    if (this.small) {
      classes.push('spinner-border-sm');
    }
    return classes;
  }
}
